import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionBlockItems: ".animation--section-introduction > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(node, [selectors.sectionBlockItems]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
